module.exports = __webpack_public_path__ + "static/img/SUP_PHOTO_TELEPHONIE.bd5560b.jpg";